import { IRootProps } from '@omni/kit/contexts/types';
import React from 'react';

export const NativePropContext = React.createContext<IRootProps>({});
